import React from 'react'

import usePortal from 'react-useportal'
import { animated, useSpring } from '@react-spring/web'
import { DesktopSearchFieldContainer } from './styles'

type SearchAnimatedProps = {
  active: boolean
  top: string
}
const SearchAnimated: React.FC<
  React.PropsWithChildren<SearchAnimatedProps>
> = ({ children, active, top }) => {
  const { Portal } = usePortal()
  const searchAnimation = useSpring({
    to: {
      top: active ? top : '0px',
      transform: `translateY(${active ? '0' : '-100%'})`,
    },
  })

  return (
    <Portal>
      <DesktopSearchFieldContainer as={animated.div} style={searchAnimation}>
        {children}
      </DesktopSearchFieldContainer>
    </Portal>
  )
}

export default SearchAnimated
